<style scoped="scoped" lang="scss"></style>
<style>
.el-select .el-input {
  width: 90px;
}

.input-with-select .el-input-group__prepend {
  background-color: #fff;
}
</style>
<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/supplier/user/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('yonghuzhanghao')">
            <el-input v-model="yt.conditions.username"></el-input>
          </el-form-item>
          <el-form-item :label="$t('yonghumingcheng')">
            <el-input v-model="yt.conditions.nickname"></el-input>
          </el-form-item>
          <el-form-item :label="$t('suoshuzuzhi')">
            <yi_data_select :type="'organization'" :idsPath.sync="yt.conditions.orgIds" :ids.sync="yt.conditions.selecteOrgId"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('gongyingshangmingcheng')">
            <yi_cross_select multiple :component="'web_wms_purchase_receipt_supplier_information'" :ids.sync="yt.conditions.supplierId"> </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('shifouqiyong')">
            <el-select v-model="yt.conditions.enabled">
              <el-option :label="$t('shi')" :value="true"></el-option>
              <el-option :label="$t('fou')" :value="false"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" v-if="utils.checkPower('web_base_supplier_account_insert')" @click="yt.showEditDialog('xinzeng', null, 'w1')" type="primary">
          {{ $t('xinzeng') }}
        </el-button>
        <!--        <el-button size="mini"  @click="show = !show" plain>-->
        <!--          {{$t('daoru')}}-->
        <!--        </el-button>-->
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <template #suoshuzuzhi="scope">
        <span>{{ scope.row.org.name }}</span>
      </template>
      <!-- 自定义某个字段 -->
      <template #juese="scope">
        <!-- 角色 -->
        <template>
          <span>{{ scope.row.roles | getRoleText }}</span>
        </template>
      </template>
      <!-- 用户账号 -->
      <!-- 	<template #yonghuzhanghao="scope">
				<template>
					<span>{{store.state.customer.code}}_{{scope.row.username}}</span>
				</template>
			</template> -->
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" v-if="utils.checkPower('web_base_supplier_account_update')" @click="yt.showEditDialog('bianji', scope.row)">{{ $t('bianji') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-popconfirm :title="$t('quedingchongzhimima?chongzhihoumima') + ':a12345678'" :confirm-button-text="$t('chongzhi')" @confirm="resetSecret(scope.row)">
              <el-button type="text" :loading="yt.editObj.loading" v-if="utils.checkPower('web_base_supplier_account_reset_passwd')" slot="reference">{{ $t('chongzhimima') }}</el-button>
            </el-popconfirm>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" class="font-color-danger" @click="yt.remove(scope.row, '/web/supplier/user/logic/delete')" v-if="utils.checkPower('web_base_supplier_account_logic_delete')">{{ $t('shanchu') }} </el-button>
          </el-col>
          <!--          <el-col :span="0.1">-->
          <!--            <el-button type="text" :loading="yt.editObj.loading" v-if="utils.checkPower('auth_user_bind_ic_card')" @click="bindIC(scope.row)">{{ $t("bangicka") }} </el-button>-->
          <!--          </el-col>-->
          <!--          <el-col :span="0.1">-->
          <!--            <el-button type="text" :loading="yt.editObj.loading" v-if="utils.checkPower('auth_user_unbind_ic_card')" @click="unbindIC(scope.row)">{{ $t("jiebangicka") }} </el-button>-->
          <!--          </el-col>-->
        </el-row>
      </template>
      <!-- 底部插槽 -->
      <!-- <div slot="footer"></div> -->
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('yonghuzhanghao')" required>
            <el-input style="width: 100px;" :placeholder="$t('qingshuruneirong')" v-model="yt.editObj.username">
              <template slot="prepend"
                >{{ store.state.customer.code }}_</template
              >
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('yonghumingcheng')" required>
            <el-input v-model="yt.editObj.nickname"></el-input>
          </el-form-item>
          <el-form-item :label="$t('suoshuzuzhi')" required>
            <yi_data_select :type="'organization'" :ids.sync="yt.editObj.orgId"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('shoujihaoma')">
            <el-input v-model="yt.editObj.mobile"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Email')">
            <el-input v-model="yt.editObj.email"></el-input>
          </el-form-item>
          <el-form-item :label="$t('juese')">
            <yi_data_select :type="'customerRole'" :ids.sync="yt.editObj.roleIds" multiple></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('shifouqiyong')" required>
            <el-select v-model="yt.editObj.enabled">
              <el-option :label="$t('shi')" :value="true"></el-option>
              <el-option :label="$t('fou')" :value="false"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('gongyingshangmingcheng')" required>
            <el-select collapse-tags v-model="yt.editObj.supplierId" filterable>
              <el-option v-for="(item, index) in supplierList" :key="index" :label="item.supplierCodeName" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/supplier/user/create')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 更新表单 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('yonghuzhanghao')" class="noborder" required>
            <!-- <span>{{store.state.customer.code}}_{{yt.editObj.username}}</span> -->
            <el-input v-model="yt.editObj.user.username" disabled=""></el-input>
          </el-form-item>
          <el-form-item :label="$t('yonghumingcheng')" required>
            <el-input v-model="yt.editObj.user.nickname"></el-input>
          </el-form-item>
          <el-form-item :label="$t('suoshuzuzhi')" required>
            <yi_data_select :type="'organization'" :ids.sync="yt.editObj.orgId"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('shoujihaoma')">
            <el-input v-model="yt.editObj.user.mobile"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Email')">
            <el-input v-model="yt.editObj.user.email"></el-input>
          </el-form-item>
          <el-form-item :label="$t('juese')">
            <yi_data_select :type="'customerRole'" :ids.sync="yt.editObj.roleIds" multiple></yi_data_select>
            <!-- <el-select filterable :clearable="true" v-model="yt.editObj.roleIds" multiple collapse-tags>
							<el-option v-for="(item, index) in rolesList" :key="index" :label="item.name"
								:value="item.id"></el-option>
						</el-select> -->
          </el-form-item>
          <el-form-item :label="$t('shifouqiyong')" required>
            <el-select v-model="yt.editObj.user.enabled">
              <el-option :label="$t('shi')" :value="true"></el-option>
              <el-option :label="$t('fou')" :value="false"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('gongyingshangmingcheng')" required>
            <el-select disabled collapse-tags v-model="yt.editObj.supplierId" filterable>
              <el-option v-for="(item, index) in supplierList" :key="index" :label="item.supplierCodeName" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/supplier/user/update', beforeAdd)" type="primary">{{ $t('baocun') }} </el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 导入excel -->
    <import_excel :show.sync="show" />
  </div>
</template>
<script type="text/javascript">
import import_excel from '@@/pages/web/system/user/import_excel';
export default {
  name: 'web_base_supplier_account_list',
  components: {
    import_excel
  },
  data() {
    return {
      show: false,
      list: [],
      rolesList: [],
      supplierList: [],
      columns: [
        {
          label: 'yonghuzhanghao',
          prop: 'user.username',
          width: 150
          // type: 'slot',
        },
        {
          label: 'yonghumingcheng',
          prop: 'user.nickname'
        },
        {
          label: 'suoshuzuzhi',
          prop: 'org',
          type: 'slot'
        },
        {
          label: 'gongyingshangmingcheng',
          prop: 'supplier.name',
          width: 150
        },
        {
          label: 'shoujihaoma',
          prop: 'user.mobile'
        },
        {
          label: 'Email',
          prop: 'user.email'
        },
        {
          label: 'juese',
          type: 'slot',
          prop: 'roles'
        },
        {
          label: 'shifouqiyong',
          prop: 'user.enabled',
          type: 'bool',
          iln18: ['shi', 'fou']
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 180,
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.getSupplierList();
      this.yt.SELECT_URL = '/web/system/auth/user/listByIds';
      this.yt.SELECT_RESULT_KEY = 'data';
      this.yt.SELECT_ID = 'id';
      this.yt.SELECT_TITLE = 'nickname';
      this.yt.get(1);
      this.getRolesList();
    }, 300);
  },
  filters: {
    getRoleText(value) {
      return value
        .map(item => {
          return item.name;
        })
        .join(',');
    }
  },
  methods: {
    beforeAdd(params, url) {
      params.username = params.user.username;
      params.nickname = params.user.nickname;
      params.mobile = params.user.mobile;
      params.email = params.user.email;
      params.enabled = params.user.enabled;
      return params;
    },
    // 获取供应商编码、名称
    async getSupplierList() {
      return await this.http
        .get(
          '/web/supplier/page?' +
            this.qs.stringify({
              pageNum: 1,
              pageSize: 999
              // orderBy: 'sort',
            })
        )
        .then(response => {
          this.supplierList = response.data.rows || [];
          for (let i = 0; i < this.supplierList.length; i++) {
            const supplierCodeName = this.supplierList[i]['code'] + '/' + this.supplierList[i]['name'];
            this.$set(this.supplierList[i], 'supplierCodeName', supplierCodeName);
          }
          console.log('this.supplierList', this.supplierList);
        });
    },
    // 重置
    clear() {
      this.yt.get(1);
    },
    async getRolesList() {
      let response = await this.http.get('/web/customer/auth/role/page', {
        params: {
          pageNum: 1,
          pageSize: 10
        }
      });
      this.rolesList = response.data.rows;
    },
    resetSecret(editObj) {
      this.http
        .post('/web/supplier/user/reset/passwd', {
          id: editObj.id
        })
        .then(res => {
          this.utils.successMessage(this.$t(res.msg));
        })
        .catch(msg => {
          this.utils.errorMessage(msg);
        });
    },

    bindIC(user) {
      //初始化卡机
      var wsr = wsrProxy;
      // 初始化 wsrProxy
      wsr.init();
      //打开刷卡端口
      let port = 0; //端口
      let block = 1; //扇区1
      //let key = "AA20210108"; // 卡密码
      let key = 'FFFFFFFFFFFF';
      let keytype = 0; //密码A
      //打开端口
      let ret = wsr.ws_openPort(port);
      let card = {
        cardno: '',
        uid: '',
        len: 0
      }; // 卡号为 字符串 string

      if (ret < 0) {
        alert(this.$t('dakaiICkaduankoushibai'));
        return;
      }

      ret = wsr.ws_getCardNo_String(port, card);
      if (ret < 0) {
        alert(this.$t('dukahaocuowu'));
        return;
      }

      this.http
        .post('/web/auth/bindIcCard', { userName: user.username, no: card.cardno })
        .then(res => {
          if (res.data == null) {
            alert(this.$t('bangdingchenggong'));
          } else {
            ret = wsr.ws_verifyKey(port, key, keytype, block);
            //验证密码失败，就先加载原始密码然后修改密码，然后再次验证
            if (ret < 0) {
              alert(this.$t('mimacuowu'));
              return;
            }

            ret = wsr.ws_writeBlock(port, 4, res.data.uid);
            if (ret < 0) {
              alert(this.$t('xieruidcuowu'));
              return;
            }
            ret = wsr.ws_writeBlock(port, 5, res.data.secret);
            if (ret < 0) {
              alert(this.$t('xierumimacuowu'));
              return;
            }
            alert(this.$t('bangdingchenggong'));
          }
        })
        .catch(msg => {
          this.utils.errorMessage(msg);
        });
    },
    unbindIC(user) {
      this.http
        .post('/web/auth/unbindIcCard', { username: user.username })
        .then(res => {
          this.utils.successMessage(this.$t('jiebangchenggong'));
        })
        .catch(msg => {
          this.utils.errorMessage(msg);
        });
    }
  }
};
</script>
